import React from "react";
import "./style.scss";
import TickIcon from "../../assets/icons/successfulTickIcon.svg";

function SuccessModal({setModalOpen, handleNavigation, title, desc, btnText}) {
  return (
    <div className="success_modal_overlay">
      <div className="success_modal_container successPopupContainer">
        <div className="success_modal_container_top popupMessageTopSection">
          <div className="tick_icon popupIcon">
            <img
              src={TickIcon}
              alt="successful tick"
            />
          </div>
        </div>
        <div className="success_modal_container_bottom popupMessageBottomSection">
          <h1>{title || "Success!"}</h1>
          <p>{desc}</p>
          <button
            className="success_modal_close_btn"
            onClick={() => {
              if (setModalOpen) setModalOpen();
              if (handleNavigation) handleNavigation();
            }}
          >
            {btnText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessModal;
